// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-recommendSection":"jobSearchDetail-recommendSection"};